module.exports = __webpack_public_path__ + "img/google_g.edd0e34f.svg";